export const PLACEHOLDER_EMPTY = 'placeholder_empty';
export const PLACEHOLDER_SELECT = 'placeholder_select';
export const LOADING = 'loading';
export const FAILED = 'failed';
export const VISIBLE = 'visible';
export const NOT_FOUND = 'not_found';
